// extracted by mini-css-extract-plugin
export var leftAlign = "_w-2";
export var popper = "_w-0";
export var subtitle = "_w-1";